/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Sleep_LabelInputs */

const en_us2_workout_sleep_label = /** @type {(inputs: Workout_Sleep_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last night's sleep`)
};

const pt_br2_workout_sleep_label = /** @type {(inputs: Workout_Sleep_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sono de ontem`)
};

const es_419_workout_sleep_label = /** @type {(inputs: Workout_Sleep_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sueño de anoche`)
};

const pt_pt2_workout_sleep_label = /** @type {(inputs: Workout_Sleep_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sono de ontem`)
};

const fr_fr2_workout_sleep_label = /** @type {(inputs: Workout_Sleep_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sommeil de la nuit`)
};

const de_de2_workout_sleep_label = /** @type {(inputs: Workout_Sleep_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlaf letzte Nacht`)
};

const it_it2_workout_sleep_label = /** @type {(inputs: Workout_Sleep_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonno di stanotte`)
};

/**
* | output |
* | --- |
* | "Last night's sleep" |
*
* @param {Workout_Sleep_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_sleep_label = /** @type {((inputs?: Workout_Sleep_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Sleep_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_sleep_label(inputs)
	if (locale === "es-419") return es_419_workout_sleep_label(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_sleep_label(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_sleep_label(inputs)
	if (locale === "de-DE") return de_de2_workout_sleep_label(inputs)
	if (locale === "it-IT") return it_it2_workout_sleep_label(inputs)
	return en_us2_workout_sleep_label(inputs)
});
export { workout_sleep_label as "workout.sleep_label" }